import * as React from "react"
import {
    Activity,
    BookOpen,
    Building,
    Building2,
    Users,
} from "lucide-react"

import { NavMain } from "@/components/ui/nav-main"
import { NavUser } from "@/components/ui/nav-user"
import { TeamSwitcher } from "@/components/ui/team-switcher"
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarRail,
} from "@/components/ui/sidebar"
import { useIsUserAdmin } from "@/hooks/authHelpers"

export function AppSidebar({ ...props }) {
    const isUserAdmin = useIsUserAdmin()

    const navMain = [
            {
                title: "Communities",
                url: "/",
                icon: Building2,
            },
            {
                title: "Secret Shops",
                url: "/secret-shops",
                icon: BookOpen,
            },
    ];

    if (isUserAdmin) {
        navMain.push(
            {
                title: "Companies",
                url: "/companies",
                icon: Building,
            },
        )

        navMain.push(
            {
                title: "Health",
                url: "/health-page",
                icon: Activity,
            },
        )

        navMain.push(
            {
                title: "Manage Users",
                url: "/users",
                icon: Users,
            },
        )
    }

    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarHeader>
                <TeamSwitcher />
            </SidebarHeader>
            <SidebarContent>
                <NavMain items={navMain} />
            </SidebarContent>
            <SidebarFooter>
                <NavUser />
            </SidebarFooter>
            <SidebarRail />
        </Sidebar>
    )
}
